import { createStore } from 'zustand'

import { amendSize } from '../../utils/size'

import {
  ImageCardOptions,
  ImageCardStore,
  ImageCardSyncState
} from './interface'

// 旋转步长
const ROTATE_STEP = 90

// 初始宽度最大值
const MAX_INITIAL_WIDTH = Infinity

export const initialImageCardStore: ImageCardSyncState = {
  ossId: undefined,
  filename: undefined,
  error: undefined,
  rotate: undefined,
  align: undefined,
  bordered: false,
  shadowed: false,
  link: undefined,
  desc: undefined,
  descInputVisible: false,
  currentHeight: 0,
  currentWidth: 0
}

export const createImageCardStore = ({
  toolbarRef,
  containerRef
}: ImageCardOptions) =>
  createStore<ImageCardStore>((set, get) => ({
    ...initialImageCardStore,
    nodeKey: '',
    toolbarRef,
    containerRef,
    getPopupContainer(triggerNode) {
      return get().toolbarRef.current ?? triggerNode
    },
    ossUrl: undefined,
    loading: false,
    active: false,
    toggleActive(active) {
      set({ active: active ?? !get().active })
    },
    originalHeight: 0,
    originalWidth: 0,
    ratio: 0,
    setOriginalSize({ width, height }) {
      const { currentHeight, currentWidth } = get()
      const originalHeight = amendSize(height)
      const originalWidth = amendSize(width)
      const ratio = originalWidth / originalHeight
      const initialWidth = Math.min(originalWidth, MAX_INITIAL_WIDTH)
      const initialHeight =
        initialWidth === originalWidth
          ? originalHeight
          : amendSize(initialWidth / ratio)
      set({
        ratio,
        originalHeight,
        originalWidth,
        currentHeight: currentHeight || initialHeight,
        currentWidth: currentWidth || initialWidth
      })
    },
    setCurrentSize({ height, width }) {
      const { currentHeight, currentWidth } = get()
      if (
        !(height && width) ||
        (currentHeight === height && currentWidth === width)
      ) {
        return
      }

      const amendedHeight = amendSize(height)
      const amendedWidth = amendSize(width)

      set({
        currentHeight: amendedHeight,
        currentWidth: amendedWidth
      })
    },
    roateIndex: 0,
    doRotate() {
      const { roateIndex } = get()
      const newIndex = (roateIndex + 1) % 4
      // 逆时针旋转
      const newRotate = 360 - newIndex * ROTATE_STEP
      set({
        rotate: newRotate,
        roateIndex: newIndex
      })
    },
    isReverseSize() {
      const { rotate = 360 } = get()
      return (rotate / ROTATE_STEP) % 2 === 1
    },
    setAlign(align) {
      set({ align })
    },
    bordered: false,
    toggleBordered(bordered) {
      set({ bordered: bordered ?? !get().bordered })
    },
    shadowed: false,
    toggleShadowed(shadowed) {
      set({ shadowed: shadowed ?? !get().shadowed })
    },
    setLink(link) {
      set({ link })
    },
    hasLink() {
      return !!get().link
    },
    openLink() {
      window.open(get().link, '_blank')
    },
    setDesc(desc) {
      set({ desc })
    },
    toggleDescInputVisible(value) {
      const { desc, descInputVisible } = get()
      const visible = desc ? true : (value ?? !descInputVisible)
      set({ descInputVisible: visible })
    }
  }))
